import { useContext, useEffect, useState } from 'preact/hooks';
import { onTeadsApiAvailable, teadsApi } from '../../teads-api';
import { PreviewContext } from '../contexts/previewContext';
import { useAdLoaded } from './useAdLoaded';

export enum Platform {
  Unknown,
  Mobile,
  Desktop,
}

export function usePlatform() {
  const isPreview = useContext(PreviewContext);
  const [platform, setPlatform] = useState(isPreview ? Platform.Desktop : Platform.Unknown);
  const onLoad = useAdLoaded();

  useEffect(() => {
    let mounted = true;

    teadsApi.isMobile(
      (err, isMobile) =>
        mounted && !err && typeof isMobile === 'boolean' && setPlatform(isMobile ? Platform.Mobile : Platform.Desktop)
    );

    const teadsPlayerApiListener = (available: any) => {
      if (mounted && !available) {
        const isMobile = navigator['userAgentData']?.mobile ?? false;

        setPlatform(isMobile ? Platform.Mobile : Platform.Desktop);
      }
    };
    onTeadsApiAvailable.subscribe(teadsPlayerApiListener);
    return () => {
      mounted = false;
      onTeadsApiAvailable.unsubscribe(teadsPlayerApiListener);
    };
  }, []);

  useEffect(() => {
    if (platform !== Platform.Unknown) {
      onLoad();
    }
  }, [platform]);

  return platform;
}
